import React from 'react';
import { useTranslations } from '@lang';

import Alert from '@common/components/Alert/Alert';
import { Button } from '@common/components';
import { formatStayDates, type NextAvailableStay as Stay } from '@features/rooms';
import { StayContent } from './NextAvailableStay.styles';

type NextAvailableStayProps = {
  stay: Stay;
  onSelectDates: () => void;
};

export const NextAvailableStay = ({ stay, onSelectDates }: NextAvailableStayProps) => {
  const { t } = useTranslations();

  return (
    <Alert
      title={t('room.nextAvailableHeader')}
      content={
        <StayContent>
          <span>{t('room.nextAvailableInfo', formatStayDates(stay))}</span>
          <Button isPrimary onClick={onSelectDates}>
            {t('room.nextAvailableCta')}
          </Button>
        </StayContent>
      }
    />
  );
};
